import { Controller } from "@hotwired/stimulus"

// Dropped pictures' painted pictures (dashboard/dropped_pictures): the ticked
// ones counted for the Add ticked / Remove ticked buttons over the list,
// and Tick all. The tick boxes belong to the #dp_bulk form; pictures added or
// removed leave the page, so the count is taken afresh each time.
export default class extends Controller {
  static targets = ["button", "note", "all", "list"]

  // Watching only the list (not the note this rewrites, which would set it off again).
  connect() {
    this.observer = new MutationObserver(() => this.count())
    if (this.hasListTarget) this.observer.observe(this.listTarget, { childList: true, subtree: true })
    this.count()
  }

  disconnect() { this.observer.disconnect() }

  boxes() { return [...document.querySelectorAll("input[form='dp_bulk'][name='ids[]']:not(:disabled)")] }

  all(event) {
    this.boxes().forEach((box) => { box.checked = event.target.checked })
    this.count()
  }

  count() {
    const boxes = this.boxes()
    const ticked = boxes.filter((box) => box.checked).length
    this.buttonTargets.forEach((button) => { button.disabled = ticked === 0 })
    const note = ticked ? `${ticked} ticked` : "Tick pictures to add or remove together."
    if (this.hasNoteTarget && this.noteTarget.textContent !== note) this.noteTarget.textContent = note
    if (this.hasAllTarget) this.allTarget.checked = boxes.length > 0 && ticked === boxes.length
  }
}
